<template>
  <el-dialog
    :title="$t('mdfeTranslate.ExportByInvoiceKeyOrBusinessOrderNumber')" :visible.sync="dialogVisible" label-position="top"
    @close="onClose"
  >
    <el-form
      ref="ruleForm" :model="ruleForm" :rules="rules"
      label-width="100px"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="">
            <el-select v-model="ruleForm.dataType">
              <el-option :label="$t('mdfeTranslate.InvoiceSecretKey')" :value="1" />
              <el-option :label="$t('receivablePayable.TicketNumber')" :value="2" />
              <el-option :label="$t('basicData.InvoiceNumber')" :value="3" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 业务类型 -->
          <el-form-item :label="$t('collectionCenter.businessT')">
            <el-select v-model="ruleForm.businessType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
              <!--快递-->
              <el-option :label="$t('collectionCenter.expressDelivery')" :value="0" />
              <!--揽收-->
              <el-option :label="$t('collectionCenter.collect')" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label=" ">
            <div ref="download1">
              <span style="cursor: pointer" @click="initDown()">
                <span style="color:#409eff;">cte导出模板(Modelo de Exportação de CTE).txt</span>
                <span class="el-icon-download" style="color:#409eff;margin-left: 20px" />
              </span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label=" " prop="orderNumber">
            <el-upload
              ref="demoUpload"
              :before-upload="beforeUpload"
              :file-list="ruleForm.orderNumber"
              :http-request="upLoad"
              :limit="1"
              :on-exceed="handleExceed"
              :on-remove="handleRemove"
              accept="text/plain"
              action
              class="upload-demo"
              drag
              multiple
            >
              <i class="el-icon-plus" style="margin: 50px auto 20px;" />
              <!-- 点击或拖拽文件到此处上传 -->
              <div class="el-upload__text">{{ $t('orderImport.cldrUpload') }}</div>
              <!--请上传.txt格式文件-->
              <div class="el-upload__text">{{ $t('spareNumberPoo.PleaseUploadTXT') }}</div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">{{ $t('basicData.Cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('basicData.determine') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { goResourceTaskList } from '@/utils/goExportList.js';
import { exportCteInvoiceByNumbers } from '@/api/invoiceCenter';

export default {
  name: '',
  data() {
    return {
      dialogVisible: false, // 按单号导出弹窗
      ruleForm: {
        dataType: 1, // 1:发票号码 2:业务单号
        businessType: 0, // 0:快递 1:揽收
        orderNumber: [] // 订单号
      },
      isUpload: false,
      upLoadFile: {},
      rules: {
        dataType: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        businessType: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        orderNumber: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ]
      }
    };
  },

  created() {

  },

  methods: {
    // 下载模板
    initDown() {
      const a = document.createElement('a');
      a.href = '/static/cte导出模板(Modelo de Exportação de CTE).txt';
      // console.log('文件地址——>', a.href);
      a.download = 'cte导出模板(Modelo de Exportação de CTE)';
      a.style.display = 'none';
      this.$nextTick(() => {
        this.$refs.download1.appendChild(a);
      });
      a.click();
      a.remove();
    },
    onOpen() {
      this.dialogVisible = true;
      this.ruleForm.dataType = 1;
      this.ruleForm.businessType = 0;
      this.ruleForm.orderNumber = [];
      this.upLoadFile = {};
      this.isUpload = false;
    },

    onClose() {
      this.ruleForm.dataType = 1;
      this.ruleForm.businessType = 0;
      this.ruleForm.orderNumber = [];
      this.upLoadFile = {};
      this.isUpload = false;
      this.dialogVisible = false;
    },
    beforeUpload(file) {
      console.log(file.type, '===file.type');
      if (file.type !== 'text/plain') {
        // 请上传 .txt 文件
        this.$message.error(this.$t('spareNumberPoo.PleaseUploadTXT'));
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        // 上传文件大小不能超过 2MB
        this.$message.error(this.$t('collectionCenter.uploadNot10MB'));
        return false;
      }
    },
    upLoad(option) {
      console.log(option, 'optionoptionoption123465');
      // 导入xlsx模版
      const files = option.file;
      this.isUpload = true;
      this.upLoadFile = new FormData();
      this.upLoadFile.append('file', files);
      this.ruleForm.orderNumber = [files];
    },
    handleRemove() {
      this.ruleForm.orderNumber = [];
      this.upLoadFile = {};
      this.isUpload = false;
    },
    handleExceed() {
      this.$message.error(this.$t('basicData.Only1FileCanBeUploadedAtATime'));
    },

    submitForm() {
      if (this.isUpload) {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) {
            // alert('submit!');
            return false;
          }
          this.exportOrderType();
        });
      } else {
        this.$message.warning(this.$t('routes.pleaseUploadFile'));
      }
    },

    /**
     * @description 按业务单号或发票号导出
     */
    exportOrderType() {
      const { dataType, businessType } = this.ruleForm;
      this.upLoadFile.append('dataType', dataType);
      this.upLoadFile.append('businessType', businessType);
      exportCteInvoiceByNumbers(this.upLoadFile).then(res => {
        if (res.code === 200) {
          // this.dialogVisible = false;
          return goResourceTaskList();
        }
      }).then(res => {
        if (res) {
          this.dialogVisible = false;
        }
      }).catch(err => {
        console.error(err);
      });
    }
  }

};
</script>

<style lang="scss" scoped>
</style>
